export default function Mailbox() {
  return (
    <div className="mb-2">
      <svg
        width="40"
        height="30"
        viewBox="0 0 40 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 10H30L36 20V25C36 26.1046 35.1046 27 34 27H6C4.89543 27 4 26.1046 4 25V20L10 10Z"
          stroke="#828282"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4 20H15L20 25L25 20H36"
          stroke="#828282"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  )
}
